var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3555 1.43181C12.3555 0.998458 12.6165 0.607777 13.0169 0.44194C13.4172 0.276104 13.8781 0.367771 14.1845 0.674197L17.6117 4.10137C18.0301 4.51979 18.0301 5.19819 17.6117 5.6166L14.1845 9.04377C13.8781 9.3502 13.4172 9.44187 13.0169 9.27603C12.6165 9.1102 12.3555 8.71951 12.3555 8.28616V6.28741H9.99973C7.00314 6.28741 4.57394 8.71663 4.57394 11.7132C4.57394 14.7097 7.00314 17.139 9.99973 17.139C12.9963 17.139 15.4255 14.7097 15.4255 11.7132C15.4255 10.9242 16.0651 10.2846 16.8541 10.2846C17.6431 10.2846 18.2827 10.9242 18.2827 11.7132C18.2827 16.2877 14.5743 19.9962 9.99973 19.9962C5.42518 19.9962 1.7168 16.2877 1.7168 11.7132C1.7168 7.13867 5.42518 3.43027 9.99973 3.43027H12.3555V1.43181Z",
  fill: "#D44500"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };